:host {
  /**
   * @prop --background: Background of the toolbar
   *
   * @prop --border-color: Color of the toolbar border
   * @prop --border-style: Style of the toolbar border
   * @prop --border-width: Width of the toolbar border
   *
   * @prop --color: Color of the toolbar text
   *
   * @prop --min-height: Minimum height of the toolbar
   *
   * @prop --opacity: Opacity of the toolbar background
   *
   * @prop --padding-top: Top padding of the toolbar
   * @prop --padding-end: Right padding if direction is left-to-right, and left padding if direction is right-to-left of the toolbar
   * @prop --padding-bottom: Bottom padding of the toolbar
   * @prop --padding-start: Left padding if direction is left-to-right, and right padding if direction is right-to-left of the toolbar
   */
  --border-width: 0;
  --border-style: solid;
  --opacity: 1;
  --opacity-scale: 1;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-padding-start: var(--ion-safe-area-left);
  padding-inline-start: var(--ion-safe-area-left);
  -webkit-padding-end: var(--ion-safe-area-right);
  padding-inline-end: var(--ion-safe-area-right);
  display: block;
  position: relative;
  width: 100%;
  color: var(--color);
  font-family: var(--ion-font-family, inherit);
  contain: content;
  z-index: 10;
  box-sizing: border-box;
}

:host(.ion-color) {
  color: var(--ion-color-contrast);
}

:host(.ion-color) .toolbar-background {
  background: var(--ion-color-base);
}

.toolbar-container {
  -webkit-padding-start: var(--padding-start);
  padding-inline-start: var(--padding-start);
  -webkit-padding-end: var(--padding-end);
  padding-inline-end: var(--padding-end);
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: var(--min-height);
  contain: content;
  overflow: hidden;
  z-index: 10;
  box-sizing: border-box;
}

.toolbar-background {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  transform: translateZ(0);
  border-width: var(--border-width);
  border-style: var(--border-style);
  border-color: var(--border-color);
  background: var(--background);
  contain: strict;
  opacity: calc(var(--opacity) * var(--opacity-scale));
  z-index: -1;
  pointer-events: none;
}

::slotted(ion-progress-bar) {
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}

:host {
  --background: var(--ion-toolbar-background, var(--ion-background-color, #fff));
  --color: var(--ion-toolbar-color, var(--ion-text-color, #424242));
  --border-color: var(--ion-toolbar-border-color, var(--ion-border-color, var(--ion-color-step-150, #c1c4cd)));
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  --min-height: 56px;
}

.toolbar-content {
  flex: 1;
  order: 3;
  min-width: 0;
  max-width: 100%;
}

::slotted(.buttons-first-slot) {
  -webkit-margin-start: 4px;
  margin-inline-start: 4px;
}

::slotted(.buttons-last-slot) {
  -webkit-margin-end: 4px;
  margin-inline-end: 4px;
}

::slotted([slot=start]) {
  order: 2;
}

::slotted([slot=secondary]) {
  order: 4;
}

::slotted([slot=primary]) {
  order: 5;
  text-align: end;
}

::slotted([slot=end]) {
  order: 6;
  text-align: end;
}